import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';
import { find } from 'lodash';

import { useGetCountries, config } from 'modules/common/helpers';

function EpTransmortalContract() {
  const { t } = useTranslation(['transmortalAuth']);
  const countries = useGetCountries();

  const userData: UserProfileDTO = useSelector(
    (state: any) => state.user.current
  );
  const { name, surname, birthday, placeOfBirth, address, zip, city } =
    userData;
  const birthdayFormated = birthday
    ? format(parseISO(birthday), config.format.uiDate)
    : '';
  const country =
    find(countries, (item) => item.value === userData.country)?.label || '';

  return (
    <div className="u-pr-20">
      <h2 className="Typography Typography--title u-weight-600 u-pb-25">
        {t('transmortalAuth:transmortal_auth_header')}
      </h2>
      <p className="u-pb-10">
        {t('transmortalAuth:transmortal_description1', {
          name,
          surname,
          birthdayFormated,
          placeOfBirth,
          address,
          zip,
          city,
          country,
        })}
      </p>
      <p className="u-pb-10">{t('transmortalAuth:transmortal_description2')}</p>
      <p className="u-pb-10">{t('transmortalAuth:transmortal_description3')}</p>
      <p className="u-pb-10">{t('transmortalAuth:transmortal_description4')}</p>
      <p className="u-pb-10">{t('transmortalAuth:transmortal_description5')}</p>
      <p className="u-pb-10">{t('transmortalAuth:transmortal_description6')}</p>
    </div>
  );
}

export default EpTransmortalContract;
